module.exports = "<app-loading></app-loading>\n<router-outlet></router-outlet>\n"